/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Dec 30 2024
 **/

import { useRef } from "react";

import { useEventHandlers } from "@rfice/eventhandler";

import Indicator from "./Indicator";
import Presets from "@/presets";
import { IDrawingData } from "@/types/types";

export default function NetworkPlayerIndicator(props: IDrawingData) {
	const { playerInfo, toolState } = props;
	const { id, name, index } = playerInfo;

	const indicatorRef = useRef<HTMLDivElement>(null);

	useEventHandlers(
		{
			onNetworkPlayerUpdate: (networkPlayerId: string, position: Vector2) => {
				if (id == networkPlayerId && indicatorRef.current) {
					indicatorRef.current.style.left = position.x + "px";
					indicatorRef.current.style.top = position.y + "px";
					indicatorRef.current.style.visibility = "visible";
				}
			},
			onNetworkPlayerEnd: (networkPlayerId: string) => {
				if (id == networkPlayerId && indicatorRef.current) {
					indicatorRef.current.style.visibility = "hidden";
				}
			}
		},
		[indicatorRef, id]
	);

	const color = Presets.penColors[index % Presets.penColors.length];

	return <Indicator ref={indicatorRef} color={color} icon={toolState} name={name} isPlayer={true} />;
}
